class RankingScreenController{

    constructor() {
        this.INDIVIDUAL_RANKING = 1;
        this.GROUP_RANKING = 2;
        this.ranking = new Ranking();
        this.slideActionsFriendList = new SlideActionsFriendList();
        const that = this;

        $(document).on("click", '.rankingDetailBtn', function() {
            var rankingId = $(this).attr('data-rankingid');
            var rankingCategoryId = $(this).attr('data-categoryrankingid');
            ga('send', 'event', analytics.GA_CATEGORY_RANKING, analytics.GA_CATEGORY_RANKING_EVENT_GO_TO_RANKING_GROUP,'');

            that.drawRankingList(that.INDIVIDUAL_RANKING, rankingId, rankingCategoryId);
        });

        $(document).on("click", '.showGroupDetailRankingBtn', function() {
            var rankingId = $(this).attr('data-rankingid');
            var rankingCategoryId = $(this).attr('data-categoryrankingid');
            var rankingGroupId = $(this).attr('data-groupid');
            var groupName = $(this).find('.ranking-details-top-item-player-name').text();
            var template=Handlebars.compile($("#worldRankingGroupMenuScreen").html());

            var context = {rankingCategoryId: rankingCategoryId,rankingId: rankingId, groupName:groupName};

            //remove old nav-menu
            if(document.querySelector(".body__container__content nav")) {
                document.querySelector(".body__container__content nav").remove();
            }

            //paint new nav
            $(".body__container__content").prepend(template(context));
            // $("#baseMenuDiv").html(template(context));

            that.drawRankingList(that.GROUP_RANKING, rankingId, rankingCategoryId, rankingGroupId);
            return false;
        });

        $(document).on("click", '.profile-link', function() {
            if(world.profile_customization.show_opponent_profile) {
                var userId = $(this).attr('data-user');
                api.getUserProfile(world.token, userId);
            }
            return false;
        });

        $(document).on("click", '#showPrevRankingBtn,#showNextRankingBtn', function() {
            const rankingId = $('#ranking-details-top-list').attr('data-ranking-id');
            const rankingCategoryId = $('#ranking-details-top-list').attr('data-ranking-category-id');
            const type = rankingCategoryId == '0' ? that.INDIVIDUAL_RANKING : that.GROUP_RANKING;
            const groupId = $('#ranking-details-top-list').attr('data-group-id');
            const offset = $(this).attr('data-offset');

            that.drawRankingList(type, rankingId, rankingCategoryId, groupId, offset);
            return false;
        });

        $(document).on("click", '#rankingGoPositionBtn', function() {
            const rankingId = $('#ranking-details-top-list').attr('data-ranking-id');
            const rankingCategoryId = $('#ranking-details-top-list').attr('data-ranking-category-id');
            const type = rankingCategoryId == '0' ? that.INDIVIDUAL_RANKING : that.GROUP_RANKING;
            const groupId = $('#ranking-details-top-list').attr('data-group-id');
            const offset = $(this).text();

            that.drawRankingList(type, rankingId, rankingCategoryId, groupId, offset, true);
            return false;
        });

        $(document).on("click", '#rankingBackLink', function() {
            let tabs = new Tabs();
            baseController.drawMainMenu(tabs.RANKING_TAB);

            let playTab = _.filter(world.world_tabs, function (tab) { return tab.id === tabs.RANKING_TAB });
            let playTabId = playTab[0].world_tab_id;
            $('#' + playTabId).trigger("click");

            return false;
        });

        $(document).on("click", '#rankingGroupBackLink', function() {
            var rankingId = $(this).attr('data-rankingid');
            var rankingCategoryId = $(this).attr('data-categoryrankingid');
            that.drawRankingList(that.INDIVIDUAL_RANKING, rankingId, rankingCategoryId);
            return false;
        });
    };

    drawRankingList(type, ranking_id, ranking_category_id, group_id, offset, goToCurrentPosition = false) {
        var request = new Object();
        var template;
        var limit = 25;
        var that = this;

        if (goToCurrentPosition) {
            offset = parseInt(offset - (limit / 2));
        }

        request.world_token = world?.token;
        request.ranking_id = ranking_id;
        request.ranking_category_id = ranking_category_id;
        request.group_id = group_id;
        request.offset = offset > 0 ? offset : 0;
        request.limit = limit;
        request = JSON.stringify(request);

        if(type === this.INDIVIDUAL_RANKING) {
            const fnRenderDropdown = () => {
                // Dibujar las pestañas del ranking individual y grupos
                template = Handlebars.compile($("#worldRankingMenuScreen").html());
                var context = {
                    ranking_category_id: ranking_category_id,
                    ranking_id: ranking_id,
                    rankings: world.rankings.rankings[0],
                    world: world
                };

                //remove old nav-menu
                if (document.querySelector(".body__container__content nav")) {
                    document.querySelector(".body__container__content nav").remove();
                }

                const tab = world.world_tabs.find(r => r.id === 3);

                if (!tab?.visible) {
                    //paint list nav
                    if ($(window).width() >= 1280) {
                        $(".fullModalHeader").append(template(context));
                    } else {
                        $(".body__container__content").prepend(template(context));
                    }
                } else {
                    //paint list nav
                    $(".body__container__content").prepend(template(context));
                }
            };

            //Paint a list of rankings
            api.getIndividualRanking(request, function(individualRankingResponse) {
                setDirectoryData(individualRankingResponse, fnRenderDropdown);
            });
        } else {
            api.getGroupRanking(request, function(groupRankingResponse) {
                setDirectoryData(groupRankingResponse);
            });
        }

        function setDirectoryData(rankingListResponse, callback = null) {

            const userWorldIds = _.uniq(_.map(rankingListResponse.result.top, 'user.user_world_id')).join(';');

            api.getUsersDirectory(userWorldIds, function(directoryResponse) {
                _.forEach(rankingListResponse.result.top, function(rankingItem) {
                    const directoryData = _.find(directoryResponse.result.users, function(user) {
                        return parseInt(rankingItem.user.user_world_id) === parseInt(user.user_world_id);
                    });
                    if (directoryData) {
                        rankingItem.user.following = directoryData.following;
                        rankingItem.user.connected = directoryData.connected;
                        rankingItem.user.chat_notifications = directoryData.chat_notifications;
                        rankingItem.user.pending_challenges = directoryData.pending_challenges;
                        rankingItem.user.followers = directoryData.followers;
                    }
                });
                drawList(rankingListResponse);

                if(callback) {
                    callback();
                }
            });

        }

        function drawList(response) {
            if (api.checkisValidResult(response)) {
                var result = response.result;
                var template;
                var context;
                var translatorRankingValue;
                var formatterUnits = 1;
                var units = '';
                var users = [];
                var icon;

                switch(result.ranking_id) {
                    case rankingScreenController.ranking.RANKING_TOP_BEST_CATEGORY:
                        translatorRankingValue = Translator.trans('TR_X_PUNTOS_AND');
                        icon = customIcons["RANKING_TOP_BEST"];
                        break;
                    case rankingScreenController.ranking.RANKING_TOP_CHALLENGE_CATEGORY:
                        translatorRankingValue = Translator.trans('TR_X_RETOS_AND');
                        icon = customIcons["RANKING_TOP_CHALLENGE"];
                        break;
                    case rankingScreenController.ranking.RANKING_TOP_WISE_CATEGORY:
                        translatorRankingValue = Translator.trans('TR_X_PREGUNTAS_AND');
                        icon = customIcons["RANKING_TOP_WISE"];
                        break;
                    case rankingScreenController.ranking.RANKING_TOP_FASTEST_CATEGORY:
                        translatorRankingValue = Translator.trans('TR_X_SEGUNDOS_AND');
                        formatterUnits = 1000;
                        icon = customIcons["RANKING_TOP_FASTEST"];
                        break;
                    case rankingScreenController.ranking.RANKING_TOP_ACCURACY_CATEGORY:
                        translatorRankingValue = Translator.trans('TR_X_RATIO_AND');
                        units = ' %';
                        icon = customIcons["RANKING_TOP_ACCURACY"];
                        break;
                }

                if (type === that.INDIVIDUAL_RANKING && ranking_category_id != 0) {  // Listado de grupos
                    _.forEach(result.top, function (ranking) {
                        ranking.group.customUnit = sprintf(translatorRankingValue, (ranking.group.points / formatterUnits)) + units;
                    });
                    template = Handlebars.compile($("#worldRankingCategoryScreen").html());
                } else {    // Listado de usuarios
                    _.forEach(result.top, function (user) {
                        user.user.customUnit = sprintf(translatorRankingValue, (user.user.points / formatterUnits)) + units;
                    });
                    template = Handlebars.compile($("#worldDetailedRankingScreen").html());
                }

                context = {
                    ranking: result,
                    world: world,
                    user: user,
                    offset: offset > 0 ? offset : 0,
                    limite: limit,
                    rankingIcon: icon,
                    userCustomization: baseController.userCustomization()
                };

                // Eliminar el user intermedio
                result.top.forEach(function (item) {
                    users.push(item.user);
                });
                worldHomeController.friends = users;

                const tab = world.world_tabs.find(r => r.id === 3);

                if(!tab.visible) {   // Dibujar la modal
                    baseController.resetStackableOrder();
                    let title = tab.name ? tab.name : 'TR_RANKING';
                    const menuTemplate = Handlebars.compile($("#fullModalMenu").html());

                    baseController.stackSimpleMenu({ title: title, icon: 'back' }, menuTemplate);
                    baseController.stackSimpleContent(template, context);
                } else {    // Dibujar la screen
                    $("#jugar").html(template(context));
                }

                // $("#jugar").html(template(context));

                $(".tintedImg").each(function () {
                    tintImage2($(this), $(this).attr('data-color'));
                });
                rankingScreenController.disableChallengeBtn();
                rankingScreenController.adaptDivToContentRankingUsersList();
                that.adaptDivToContentRankingUsersList();

                const currentUserDiv = $('.ranking-details-top-item[data-ranking="' + result.user_position + '"]');
                if (currentUserDiv.length) {
                    $('html, body').animate({
                        scrollTop: currentUserDiv.offset().top
                    }, 500);
                }

                $("#ranking-details-top-list").off().on("click.openFriendProfile", ".friend-item.is-ranking", function() {
                    api.getUserProfile(world.token, $(this).data("user"), false);
                });

                that.slideActionsFriendList.initialize();

            }
        }
    }

    draw() {
        $(".tintedImg").each(function(){
            tintImage2($(this),$(this).attr('data-color'));
        });
        // Ajustar al alto de la ventana, si no llega..
        var content = $('.content');

        if(content && content.offset()) {
            var contentTop = content.offset().top;
            var contentBottom = contentTop + content.outerHeight();
            var windowHeight = $(window).height();
            var diff = windowHeight - contentBottom;
        } else {
            var diff = 0;
        }

        if (diff > 0) {
            var rows = $('#otherRankings').find('tr');
            var numRows = rows.length;
            var extraHeight = Math.floor(diff / numRows);

            rows.each(function(i, row) {
                var firstCell = $(row).find('td').first();
                var cellHeight = firstCell.outerHeight();
                firstCell.outerHeight(cellHeight + extraHeight);
            });

            if (diff % numRows != 0) {
                var podium = $('.podium');
                podium.outerHeight(podium.outerHeight() + 1);
            }
        }

        let height = 40;

        if ($(window).width() <= 420) {
            height = 30;
        }

        // Añadir los puntos suspensivos en los nombres del podium.
        $(".podium-player-name").dotdotdot({
            height: height,
            watch: true,
        })

    };

    disableChallengeBtn() {
        const challengeBtn = $('.rankingChallengeBtn[data-userid="' + user.user_world_id + '"]').children();
        challengeBtn.addClass('bg-disabled');
        challengeBtn.removeClass('world_color_1_bg');
    }

    adaptDivToContentRankingUsersList() {
        const allSpace = $('.user-list-div').width();
        const imageSpace = $('.ranking-details-top-item-player-image:visible').outerWidth(true);
        const challengeBtn = $('.ranking-details-top-item-challenge-btn').outerWidth(true);
        const chatBtn = $('.chat-btn').outerWidth(true);
        const userDetailsMaxWidth = allSpace - (imageSpace + challengeBtn + chatBtn + 25);  // El 25 para darle un margen y no apurar demasiado
        if(userDetailsMaxWidth > 0) {
            $('.ranking-details-top-item-player-info').css('width', userDetailsMaxWidth);
        }

        $('.user-list-div').each(function () {
            // Para adaptar el tamaño del email
            const userBubble = $(this).find('.link-user-label');

            if(userBubble) {
                const userEmailBubble = $(this).find('#link-user-label-email');
                const userPhoneBubble = $(this).find('#link-user-label-phone').outerWidth(true);
                const widthUserEmailBubble = userEmailBubble.parent().innerWidth() - userPhoneBubble - 10; // Margen de 10 para que no salte de linea
                userEmailBubble.css('max-width', widthUserEmailBubble);
            }
        });
    }
}